import { useRef, useState } from "react";
import { Col, Form, FormGroup, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import SignatureCanvas from "react-signature-canvas";
import { reduce_image_file_size } from "../Utils";
import PopupWrapper from "./PopupWrapper";
import { BlurWrapperWithSpan } from "../Utils/CustomComponent";

const ChequeComponent = ({
  formData,
  handleChange,
  readOnly,
  chequeNumber,
  setSign,
}) => {
  const chequeData = useSelector((state) => state.achPayment.sameDayPayment);
  const { isLargeDevice } = useSelector((state) => state.RS_Sidebar);
  const [showSignaturePad, setShowSignaturePad] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const signatureRef = useRef(null);
  const saveSignature = async (e) => {
    e.preventDefault();
    setSign(null);

    function validateStrokes() {
      const strokeData = signatureRef.current.toData();
      const minStrokeLength = 50; // Minimum stroke length (in pixels)

      let totalLength = 0;

      strokeData.forEach((stroke) => {
        let strokeLength = 0;
        for (let i = 1; i < stroke.length; i++) {
          const dx = stroke[i].x - stroke[i - 1].x;
          const dy = stroke[i].y - stroke[i - 1].y;
          strokeLength += Math.sqrt(dx * dx + dy * dy);
        }
        totalLength += strokeLength;
      });

      if (totalLength < minStrokeLength) {
        return false;
      } else {
        return true;
      }
    }
    if (signatureRef.current) {
      if (signatureRef.current.isEmpty()) {
        setShowAlert(true);
        return;
      }
      const isValid = validateStrokes();
      if (isValid) {
        const signature = signatureRef.current
          .getTrimmedCanvas()
          .toDataURL("image/png");
        // const res = await reduce_image_file_size(signature);

        // if (res.length > 4000) {
        //   alert("Signature size exceeds 4000 characters. Please try again.");
        //   return;
        // }
        setSign(signature);
        const e = { target: { name: "signature", value: signature } };
        handleChange(e);
        setShowSignaturePad(false);
      } else {
        setShowAlert(true);
      }
    }
  };

  const clearSignature = (e) => {
    e.preventDefault();
    if (signatureRef.current) {
      signatureRef.current.clear();
    }
    setSign(null);
  };
  return (
    <>
      <Row className="mt-5">
        <Col md={12} sm={12}>
          <div
            style={{
              border: "2px solid black",
              padding: "20px",
              borderRadius: "8px",
              fontFamily: "Courier, monospace",
            }}
          >
            <Row className="mb-5">
              <Col md={7} sm={7} style={{ lineHeight: "initial" }}>
                <BlurWrapperWithSpan>
                  {chequeData.bankAccountName} <br />
                </BlurWrapperWithSpan>
                <div style={{ fontSize: "12px" }}>
                  <BlurWrapperWithSpan>
                    {chequeData.address} <br />
                    {chequeData.cityStateZip} <br />
                  </BlurWrapperWithSpan>
                </div>
              </Col>
              <Col md={3} sm={3}>
                <FormGroup
                  className="w-100"
                  style={{ borderBottom: "2px solid black" }}
                >
                  <Row style={!isLargeDevice ? { fontSize: "smaller" } : null}>
                    <Col md={3} sm={3}>
                      <label htmlFor="payTo">Date</label>
                    </Col>
                    <Col md={9} sm={9}>
                      <input
                        style={{
                          border: "none",
                          outline: "none",
                          background: "white",
                          width: "100%",
                        }}
                        type="text"
                        name="date"
                        disabled={readOnly}
                        id="date"
                        value={formData.date}
                        onChange={handleChange}
                      />
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
              <Col md={2} sm={2}>
                <FormGroup
                  className="w-100"
                  style={{ borderBottom: "2px solid black" }}
                >
                  <Row style={!isLargeDevice ? { fontSize: "smaller" } : null}>
                    <Col md={12} sm={12}>
                      <BlurWrapperWithSpan>
                        <input
                          style={{
                            border: "none",
                            outline: "none",
                            background: "white",
                            width: "100%",
                            fontWeight: "700",
                          }}
                          type="text"
                          name="chequeNumber"
                          disabled={readOnly}
                          id="chequeNumber"
                          value={chequeNumber ? chequeNumber : ""}
                        />
                      </BlurWrapperWithSpan>
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
            </Row>
            <Form>
              <Row className="mb-5">
                <Col md={7} sm={7}>
                  <FormGroup
                    className="w-100"
                    style={{ borderBottom: "2px solid black" }}
                  >
                    <Row>
                      <Col md={2} sm={3}>
                        <label
                          htmlFor="payTo"
                          style={{
                            fontSize: isLargeDevice ? "13px" : "smaller",
                            lineHeight: "12px",
                          }}
                        >
                          Pay to the Order of
                        </label>
                      </Col>
                      <Col
                        md={9}
                        sm={9}
                        style={!isLargeDevice ? { alignSelf: "center" } : null}
                      >
                        <input
                          style={{
                            border: "none",
                            outline: "none",
                            background: "white",
                            width: "100%",
                          }}
                          type="text"
                          name="payTo"
                          value={formData.payTo}
                          disabled={readOnly}
                          id="payTo"
                          onChange={handleChange}
                        />
                      </Col>
                    </Row>
                  </FormGroup>
                </Col>
                <Col md={5} sm={5}>
                  <FormGroup>
                    <input
                      style={{
                        outline: "none",
                        background: "white",
                      }}
                      type="text"
                      name="amount"
                      id="amount"
                      disabled={readOnly}
                      value={`$${formData.amount}`}
                      onChange={handleChange}
                      placeholder="$Dollar"
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row className="mb-5">
                <Col md={12} sm={12}>
                  <FormGroup
                    className="w-100"
                    style={{ borderBottom: "2px solid black" }}
                  >
                    <input
                      style={{
                        border: "none",
                        outline: "none",
                        background: "white",
                      }}
                      className="w-100"
                      type="text"
                      name="amountInWords"
                      disabled={readOnly}
                      value={formData.amountInWords}
                      id="amountInWords"
                      onChange={handleChange}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                {" "}
                <BlurWrapperWithSpan>
                  <div style={{ lineHeight: "initial" }}>
                    {chequeData.bankName}
                    <br />
                    <div style={{ fontSize: "12px" }}>
                      {chequeData.bankAddress}
                      <br />
                      {chequeData.bankCity}, {chequeData.bankState} -{" "}
                      {chequeData.bankZip}
                      <br />
                      {chequeData.bankTelephone}
                      <br />
                    </div>
                  </div>
                </BlurWrapperWithSpan>
                <Col md={9} sm={9} className="mt-5">
                  <FormGroup
                    className="w-100"
                    style={{ borderBottom: "2px solid black" }}
                  >
                    <Row>
                      <Col md={1} sm={1}>
                        <label htmlFor="memo">Memo</label>
                      </Col>
                      <Col md={9} sm={9}>
                        <BlurWrapperWithSpan>
                          <input
                            style={{
                              border: "none",
                              outline: "none",
                              background: "white",

                              width: "100%",
                            }}
                            type="text"
                            name="memo"
                            id="memo"
                            disabled={readOnly}
                            value={formData.memo}
                            onChange={handleChange}
                          />
                        </BlurWrapperWithSpan>
                      </Col>
                    </Row>
                  </FormGroup>
                </Col>
                <Col md={3} sm={3}>
                  <FormGroup
                    className="w-100"
                    style={{ borderBottom: "2px solid black" }}
                  >
                    {formData.signature ? (
                      <img
                        src={formData.signature}
                        alt="Signature"
                        style={{
                          // width: "50px",
                          height: "40px",
                          objectFit: "scale-down",
                        }}
                        onClick={() => !readOnly && setShowSignaturePad(true)}
                      />
                    ) : (
                      <div
                        className="mt-5"
                        onClick={() => setShowSignaturePad(true)}
                      >
                        Click to sign
                      </div>
                    )}
                  </FormGroup>
                </Col>
              </Row>
              <Row className="mt-3">
                <BlurWrapperWithSpan>
                  <p
                    style={{
                      fontFamily: "specialenFont",
                      fontSize: isLargeDevice ? "25px" : "15px",
                    }}
                  >
                    {/* {formData?.chequeNo} */}A
                    <span>{chequeData.routingNumber}A</span>
                    <span>{chequeData.accountNumber}C</span>
                    {chequeNumber}
                  </p>
                </BlurWrapperWithSpan>
              </Row>
              {/* Signature Pad Modal */}
              {showSignaturePad && (
                <div
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 1000,
                  }}
                >
                  <div
                    style={{
                      // width: "100%",
                      height: "340px",
                      backgroundColor: "white",
                      padding: "20px",
                      position: "relative",
                    }}
                  >
                    <SignatureCanvas
                      ref={signatureRef}
                      penColor="black"
                      canvasProps={{
                        // width: "1200px",
                        // height: "600px",
                        width: "760px",
                        height: "260px",
                        className: "sigCanvas",
                      }}
                    />
                    <button
                      onClick={saveSignature}
                      style={{
                        position: "absolute",
                        right: "20px",
                        bottom: "20px",
                      }}
                    >
                      Save
                    </button>
                    <button
                      onClick={clearSignature}
                      style={{
                        position: "absolute",
                        left: "20px",
                        bottom: "20px",
                      }}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              )}
            </Form>
          </div>
        </Col>
      </Row>
      <CustomAlert showAlert={showAlert} setShowAlert={setShowAlert} />
    </>
  );
};
export default ChequeComponent;

const CustomAlert = ({ showAlert, setShowAlert }) => {
  return (
    <PopupWrapper
      title=""
      extraClass="width-800"
      Component={
        <div>
          <p className="fw-bold text-center">
            Valid signature should be seen on the check before submitting.
          </p>
          <div className="d-flex justify-content-end gap-5 mb-3">
            <button
              className="btn btn-primary"
              onClick={() => setShowAlert(false)}
            >
              Ok
            </button>
          </div>
        </div>
      }
      toShow={showAlert}
      closeEventHandler={() => setShowAlert(false)}
    />
  );
};
